import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  Paper
} from '@material-ui/core'
import { Form, Formik } from 'formik'
import { useEffect, useState } from 'react'
import ConfirmationModal from '../ConfirmationModal'


import { CircleHelp } from 'lucide-react'
import { toast } from 'react-toastify'
import useHelps from '../../hooks/useHelps'
import { ButtonPrimary } from '../ButtonPrimary'
import { ButtonSecondary } from '../ButtonSecondary'
import { InputField } from '../InputField'
import QuickTable from '../QuickTable'
import SelectInput from '../SelectInput'
import { useStyles } from './style'

const HELP_PAGE_OPTIONS = [
  { value: 'Dashboard', label: 'Dashboard' },
  { value: 'Atendimentos', label: 'Atendimentos' },
  { value: 'RespostasRapidas', label: 'Respostas Rápidas' },
  { value: 'Agendamento', label: 'Agendamentos' },
  { value: 'Tags', label: 'Tags' },
  { value: 'Tasks', label: 'Tarefas' },
  { value: 'Lembretes', label: 'Lembretes' },
  { value: 'Contatos', label: 'Contatos' },
  { value: 'Clientes', label: 'Clientes' },
  { value: 'ArquivosContato', label: 'Arquivos de Contato' },
  { value: 'Campanhas', label: 'Campanhas' },
  { value: 'ListaContatos', label: 'Lista de Contatos' },
  { value: 'Financeiro', label: 'Financeiro' },
  { value: 'Anuncios', label: 'Anúncios' },
  { value: 'Usuarios', label: 'Usuários' },
  { value: 'Relatorios', label: 'Relatórios' },
  { value: 'PainelGestor', label: 'Painel Gestor' },
  { value: 'Conexoes', label: 'Conexões' },
  { value: 'Departamentos', label: 'Departamentos' },
  { value: 'Configuracoes', label: 'Configurações' },
  { value: 'Wizard', label: 'Wizard' },
  { value: 'ChatInterno', label: 'Chat Interno' }
]

// export function HelpManagerForm(props) {
//   const { onSubmit, onDelete, onCancel, initialValue, loading } = props
//   const classes = useStyles()

//   const [record, setRecord] = useState(initialValue)

//   useEffect(() => {
//     setRecord(initialValue)
//   }, [initialValue])

//   const handleSubmit = async data => {
//     onSubmit(data)
//   }

//   return (
//     <Formik
//       enableReinitialize
//       className={classes.fullWidth}
//       initialValues={record}
//       onSubmit={(values, { resetForm }) =>
//         setTimeout(() => {
//           handleSubmit(values)
//           resetForm()
//         }, 500)
//       }
//     >
//       {values => (
//         <Form className={classes.fullWidth}>
//           <Grid spacing={2} justifyContent="flex-end" container>
//             <Grid xs={12} sm={6} md={3} item>
//               <Field
//                 as={TextField}
//                 label="Título"
//                 name="title"
//                 variant="outlined"
//                 className={classes.fullWidth}
//                 margin="dense"
//               />
//             </Grid>
//             <Grid xs={12} sm={6} md={3} item>
//               <Field
//                 as={TextField}
//                 label="Código do Vídeo"
//                 name="video"
//                 variant="outlined"
//                 className={classes.fullWidth}
//                 margin="dense"
//               />
//             </Grid>
//             <Grid xs={12} sm={6} md={3} item>
//               <Field
//                 as={TextField}
//                 label="Descrição"
//                 name="description"
//                 variant="outlined"
//                 className={classes.fullWidth}
//                 margin="dense"
//               />
//             </Grid>
//             <Grid xs={12} sm={6} md={3} item>
//               <FormControl style={{ width: '100%', padding: 10 }}>
//                 <Field
//                   as={Select}
//                   labelId="Link-id"
//                   name="link"
//                   variant="outlined"
//                   margin="dense"
//                 >
//                   <MenuItem value={'Atendimentos'}>Atendimentos</MenuItem>
//                   <MenuItem value={'RespostasRapidas'}>
//                     Respostas Rapidas
//                   </MenuItem>
//                   <MenuItem value={'Contatos'}>Contatos</MenuItem>
//                   <MenuItem value={'Agendamento'}>Agendamento</MenuItem>
//                   <MenuItem value={'Tags'}>Tags</MenuItem>
//                   <MenuItem value={'ChatInterno'}>Chat Interno</MenuItem>
//                   <MenuItem value={'Wizard'}>Wizard</MenuItem>
//                 </Field>
//               </FormControl>
//             </Grid>
//             <Grid sm={3} md={1} item>
//               <ButtonWithSpinner
//                 className={classes.fullWidth}
//                 loading={loading}
//                 onClick={() => onCancel()}
//                 variant="contained"
//               >
//                 Limpar
//               </ButtonWithSpinner>
//             </Grid>
//             {record.id !== undefined ? (
//               <Grid sm={3} md={1} item>
//                 <ButtonWithSpinner
//                   className={classes.fullWidth}
//                   loading={loading}
//                   onClick={() => onDelete(record)}
//                   variant="contained"
//                   color="secondary"
//                 >
//                   Excluir
//                 </ButtonWithSpinner>
//               </Grid>
//             ) : null}
//             <Grid sm={3} md={1} item>
//               <ButtonWithSpinner
//                 className={classes.fullWidth}
//                 loading={loading}
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//               >
//                 Salvar
//               </ButtonWithSpinner>
//             </Grid>
//           </Grid>
//         </Form>
//       )}
//     </Formik>
//   )
// }

// export function HelpsManagerGrid(props) {
//   const { records, onSelect } = props
//   const classes = useStyles()

//   return (
//     <Paper className={classes.tableContainer}>
//       <Table
//         className={classes.fullWidth}
//         size="small"
//         aria-label="a dense table"
//       >
//         <TableHead>
//           <TableRow>
//             <TableCell align="center" style={{ width: '1%' }}>
//               #
//             </TableCell>
//             <TableCell align="left">Título</TableCell>
//             <TableCell align="left">Descrição</TableCell>
//             <TableCell align="left">Vídeo</TableCell>
//             <TableCell align="left">Pagina</TableCell>
//           </TableRow>
//         </TableHead>
//         <TableBody>
//           {records.map(row => (
//             <TableRow key={row.id}>
//               <TableCell align="center" style={{ width: '1%' }}>
//                 <IconButton onClick={() => onSelect(row)} aria-label="delete">
//                   <EditIcon />
//                 </IconButton>
//               </TableCell>
//               <TableCell align="left">{row.title || '-'}</TableCell>
//               <TableCell align="left">{row.description || '-'}</TableCell>
//               <TableCell align="left">{row.video || '-'}</TableCell>
//               <TableCell align="left">{row.link || '-'}</TableCell>
//             </TableRow>
//           ))}
//         </TableBody>
//       </Table>
//     </Paper>
//   )
// }

export default function HelpsManager() {
  const classes = useStyles()
  const { list, save, update, remove } = useHelps()

  const [showConfirmDialog, setShowConfirmDialog] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [records, setRecords] = useState([])
  const [record, setRecord] = useState({
    title: '',
    description: '',
    video: '',
    link: ''
  })

  const columns = [
    {
      field: 'title',
      headerName: 'Título',
      align: 'center'
    },
    {
      field: 'description',
      headerName: 'Descrição',
      align: 'center'
    },
    {
      field: 'video',
      headerName: 'Url',
      align: 'center'
    },
    {
      field: 'link',
      headerName: 'Página',
      align: 'center'
    }
  ]

  useEffect(() => {
    async function fetchData() {
      await loadHelps()
    }
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const loadHelps = async () => {
    setLoading(true)
    try {
      const helpList = await list()
      setRecords(helpList)
    } catch (e) {
      toast.error('Não foi possível carregar a lista de registros')
    }
    setLoading(false)
  }

  const handleSubmit = async data => {
    setLoading(true)
    try {
      if (data.id !== undefined) {
        await update(data)
      } else {
        await save(data)
      }
      await loadHelps()
      handleCancel()
      toast.success('Operação realizada com sucesso!')
    } catch (e) {
      toast.error(
        'Não foi possível realizar a operação. Verifique se já existe uma helpo com o mesmo nome ou se os campos foram preenchidos corretamente'
      )
    }
    setLoading(false)
  }

  const handleDelete = async () => {
    setLoading(true)
    try {
      await remove(record.id)
      await loadHelps()
      handleCancel()
      toast.success('Operação realizada com sucesso!')
    } catch (e) {
      toast.error('Não foi possível realizar a operação')
    }
    setLoading(false)
  }

  // const handleOpenDeleteDialog = () => {
  //   setShowConfirmDialog(true)
  // }

  const handleDeleteFromTable = data => {
    setRecord(data)
    setShowConfirmDialog(true)
  }

  const handleCancel = () => {
    setRecord({
      title: '',
      description: '',
      video: '',
      link: ''
    })
    setModalOpen(false)
  }

  const handleSelect = data => {
    setRecord({
      id: data.id,
      title: data.title || '',
      description: data.description || '',
      video: data.video || '',
      link: data.link || ''
    })
    setModalOpen(true)
  }

  const handleOpenModal = () => {
    setRecord({
      title: '',
      description: '',
      video: '',
      link: ''
    })
    setModalOpen(true)
  }

  return (
    <Paper className={classes.mainPaper} elevation={0}>
      <Grid spacing={2} container>
        <Grid xs={12} item style={{ textAlign: 'right' }}>
          <Button
            variant="contained"
            onClick={handleOpenModal}
            className={classes.buttonNewTutorial}
            startIcon={<CircleHelp />}
          >
            Novo Tutorial
          </Button>
        </Grid>
        <Grid xs={12} item>
          {/* <HelpsManagerGrid records={records} onSelect={handleSelect} /> */}
          <QuickTable
            data={records || []}
            columns={columns}
            loading={loading}
            actions={['edit', 'delete']}
            onEdit={handleSelect}
            onDelete={handleDeleteFromTable}
            emptyMessage="Nenhum tutorial encontrado."
            skeletonRows={5}
            containerProps={{ elevation: 0 }}
          />
        </Grid>
      </Grid>
      <ConfirmationModal
        title="Exclusão de Registro"
        open={showConfirmDialog}
        onClose={() => setShowConfirmDialog(false)}
        onConfirm={() => handleDelete()}
      >
        Deseja realmente excluir esse registro?
      </ConfirmationModal>
      <Dialog
        open={modalOpen}
        onClose={handleCancel}
        maxWidth="xs"
        scroll="paper"
      >
        <DialogTitle className={classes.dialogTitle}>
          {record.id ? 'Editar Tutorial' : 'Adicionar Tutorial'}
        </DialogTitle>
        <Formik
          enableReinitialize
          className={classes.fullWidth}
          initialValues={record}
          onSubmit={async (values, { resetForm }) => {
            await handleSubmit(values)
            resetForm()
          }}
        >
          {({ touched, errors, isSubmitting, values, setFieldValue }) => (
            <Form className={classes.fullWidth}>
              <DialogContent dividers>
                <Grid spacing={2} container>
                  <Grid xs={12} item>
                    <InputField
                      label="Título"
                      name="title"
                      value={values.title}
                    />
                    {/* <Field
                      as={TextField}
                      label="Título"
                      name="title"
                      variant="outlined"
                      className={classes.fullWidth}
                      margin="dense"
                    /> */}
                  </Grid>
                  <Grid xs={12} item>
                    <InputField
                      label="Descrição"
                      name="description"
                      value={values.description}
                    />
                    {/* <Field
                      as={TextField}
                      label="Descrição"
                      name="description"
                      variant="outlined"
                      className={classes.fullWidth}
                      margin="dense"
                    /> */}
                  </Grid>
                  <Grid xs={12} item>
                    <InputField
                      label="Url do Vídeo"
                      name="video"
                      value={values.video}
                    />
                    {/* <Field
                      as={TextField}
                      label="Código do Vídeo"
                      name="video"
                      variant="outlined"
                      className={classes.fullWidth}
                      margin="dense"
                    /> */}
                  </Grid>

                  <Grid xs={12} item>
                    <SelectInput
                      label="Página"
                      name="link"
                      value={values.link}
                      onChange={e => setFieldValue('link', e.target.value)}
                    >
                      {HELP_PAGE_OPTIONS.map(page => (
                        <MenuItem key={page.value} value={page.value}>
                          {page.label}
                        </MenuItem>
                      ))}
                    </SelectInput>
                    {/* <FormControl style={{ width: '100%', padding: 10 }}>
                      <Field
                        as={Select}
                        labelId="Link-id"
                        name="link"
                        variant="outlined"
                        margin="dense"
                      >
                        <MenuItem value={'Atendimentos'}>Atendimentos</MenuItem>
                        <MenuItem value={'RespostasRapidas'}>
                          Respostas Rapidas
                        </MenuItem>
                        <MenuItem value={'Contatos'}>Contatos</MenuItem>
                        <MenuItem value={'Agendamento'}>Agendamento</MenuItem>
                        <MenuItem value={'Tags'}>Tags</MenuItem>
                        <MenuItem value={'ChatInterno'}>Chat Interno</MenuItem>
                        <MenuItem value={'Wizard'}>Wizard</MenuItem>
                      </Field>
                    </FormControl> */}
                  </Grid>
                  {/* <Grid sm={3} md={1} item>
              <ButtonWithSpinner
                className={classes.fullWidth}
                loading={loading}
                onClick={() => onCancel()}
                variant="contained"
              >
                Limpar
              </ButtonWithSpinner>
            </Grid>
            {record.id !== undefined ? (
              <Grid sm={3} md={1} item>
                <ButtonWithSpinner
                  className={classes.fullWidth}
                  loading={loading}
                  onClick={() => onDelete(record)}
                  variant="contained"
                  color="secondary"
                >
                  Excluir
                </ButtonWithSpinner>
              </Grid>
            ) : null}
            <Grid sm={3} md={1} item>
              <ButtonWithSpinner
                className={classes.fullWidth}
                loading={loading}
                type="submit"
                variant="contained"
                color="primary"
              >
                Salvar
              </ButtonWithSpinner>
            </Grid> */}
                </Grid>
              </DialogContent>
              <DialogActions>
                <ButtonSecondary
                  onClick={handleCancel}
                  disabled={isSubmitting}
                  label="CANCELAR"
                />
                <ButtonPrimary
                  type="submit"
                  color="primary"
                  disabled={isSubmitting}
                  variant="contained"
                  label={record.id ? 'SALVAR' : 'ADICIONAR'}
                />
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    </Paper>
  )
}
